var page_data = page_data || {};
var generic = generic || {};
var site = site || {};

(function ($) {
  'use strict';

  Drupal.behaviors.email_signup_uk_v1 = {
    init: function (context) {
      var self = this;
      var args = {
        $button_submit: $('#roulette_newsletter_submit_button', context),
        $terms_checkbox: $('#email_terms_popover_checkbox', context),
        $terms_error: $('.js-email-terms__error', context),
        $terms_mandatory: $('#email_terms_mandatory', context)
      };

      args.$button_submit.click(function (e) {
        if (typeof args.$terms_mandatory === 'undefined' || !args.$terms_mandatory || !args.$terms_mandatory.length) {
          return;
        }
        if (args.$terms_checkbox.is(':checked')) {
          args.$terms_error.addClass('hidden');
        } else {
          e.preventDefault();
          args.$terms_error.removeClass('hidden');
        }
      });
    },
    attach: function (context) {
      this.init(context);
    }
  };
})(jQuery);
